import gsap from 'gsap'
import { prefersReducedMotion } from '@/ui/motion'

let removeListener

export function initGlobalTouchEffect() {
  if (removeListener) return removeListener
  let lastClick = 0
  const onClick = (event) => {
    if (prefersReducedMotion() || event.detail === 0 || performance.now() - lastClick < 100) return
    lastClick = performance.now()
    createTouchSparkEffect(event.clientX, event.clientY)
  }
  removeListener = () => {
    window.removeEventListener('click', onClick)
    document.querySelectorAll('.global-touch-ripple, .global-touch-star').forEach(el => {
      gsap.killTweensOf(el)
      el.remove()
    })
    removeListener = undefined
  }
  window.addEventListener('click', onClick, { passive: true })
  return removeListener
}

function createTouchSparkEffect(x, y) {
  const ripple = document.createElement('div')
  ripple.className = 'global-touch-ripple'
  ripple.style.left = `${x}px`
  ripple.style.top = `${y}px`
  document.body.appendChild(ripple)

  gsap.fromTo(
    ripple,
    { scale: 0.25, opacity: 0.92 },
    {
      scale: 1.9,
      opacity: 0,
      duration: 0.52,
      ease: 'power2.out',
      onComplete: () => ripple.remove(),
    }
  )

  const count = 4
  for (let i = 0; i < count; i++) {
    const star = document.createElement('div')
    star.className = 'global-touch-star'
    star.style.left = `${x}px`
    star.style.top = `${y}px`
    star.style.width = `${6 + Math.random() * 6}px`
    star.style.height = star.style.width
    document.body.appendChild(star)

    const angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.45
    const distance = 20 + Math.random() * 24
    const dx = Math.cos(angle) * distance
    const dy = Math.sin(angle) * distance

    gsap.fromTo(
      star,
      { x: 0, y: 0, scale: 0.45, opacity: 0.95, rotate: Math.random() * 60 },
      {
        x: dx,
        y: dy,
        scale: 0.15,
        opacity: 0,
        rotate: 140 + Math.random() * 160,
        duration: 0.6 + Math.random() * 0.18,
        ease: 'power2.out',
        onComplete: () => star.remove(),
      }
    )
  }
}
